module.exports = __webpack_public_path__ + "img/logo_placeholder.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo_placeholder.png
// module id = 69
// module chunks = 0